import * as React from "react";

function IconLeftBottomFoldedPaper(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 41 40" fill="none" {...props}>
      <g
        clipPath="url(#prefix__clip0_1055_7388)"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path
          d="M6.999 4.98v29.04A1.98 1.98 0 008.979 36h16.17l9.9-9.9V4.98A1.98 1.98 0 0033.069 3H8.979a1.98 1.98 0 00-1.98 1.98z"
          fill="#E5E9EE"
        />
        <path
          d="M27.13 26.1h7.92l-9.9 9.9v-7.92a1.98 1.98 0 011.98-1.98z"
          fill="#C0C7D1"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_1055_7388">
          <path fill="#fff" transform="translate(.5)" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconLeftBottomFoldedPaper = React.memo(IconLeftBottomFoldedPaper);
export default MemoIconLeftBottomFoldedPaper;
